import { render, staticRenderFns } from "./appointSucc.vue?vue&type=template&id=6f93f2e6&scoped=true&"
import script from "./appointSucc.vue?vue&type=script&lang=js&"
export * from "./appointSucc.vue?vue&type=script&lang=js&"
import style0 from "./appointSucc.vue?vue&type=style&index=0&id=6f93f2e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f93f2e6",
  null
  
)

export default component.exports